import { PlayerDto } from '../Dtos/PlayerDto';

export class GetPlayersRequest {
    static Message = 'GetPlayersRequest';

    public gameId: string;

    constructor(gameId: string) {
        this.gameId = gameId;
    }
}

export class GetPlayersResponse {
    static Message = 'GetPlayersResponse';

    public players: PlayerDto[];

    constructor(players: PlayerDto[]) {
        this.players = players;
    }
}
